<template>
  <div class="table-wrap">
    <el-row>
      <el-col
        v-for="(item,index) of list"
        :class="{'hidden-xs-only':!item.label}"
        :xs="24"
        :sm="item.span"
        :md="item.span"
        :lg="item.span"
        :span="item.span"
        :key="index">
        <div class="table-content-item" :style="itemHeightStyle(item)">
          <div class="content-label" :style="[{width: labelWidthCup},{'background-color': !item.label ? '#fff' : null}]">
            {{item.label}}
          </div>
          <div class="content" :style="{width: `calc(100% - ${labelWidthCup})`}" :ad="componentDidMount(item.prop)">
            <el-tooltip
              :content="value[item.prop]"
              placement="top"
              popper-class="content-tooltip"
              effect="light"
              :disabled="disabledTools(item)">
              <div class="content-text" :style="contentStyle(item)" :ref="item.prop">{{value[item.prop]}}</div>
            </el-tooltip>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import 'element-ui/lib/theme-chalk/display.css';

  export default {
    name: "TableForm",
    components: {},
    directives: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
      return {
        labelWidthCup: '120px',
        label: '姓名姓名姓姓姓名姓名姓名姓名',
        value: {
          name: '这是内容这是内容这是内容这是内容这是内容这' +
            '这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容是内容这是内容这是内容这是内容这是内容这是内容这是内容',
          remark: '这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容是内容这是内容这是内容这是内容这是内容这是内容这是内容'
        },
        list: [
          {
            label: '姓名姓名姓名姓名姓名',
            prop: 'name',
            span: 8,
          },
          {
            span: 8,
          },
          {
            span: 8,
          },
          {
            label: '姓名',
            prop: 'remark',
            span: 24,
            minHeight: '60px'
          },
        ],
        ellipsisList: []
      }
    },
    watch: {},
    methods: {
      itemHeightStyle(item) {
        if (item.minHeight) {
          return {minHeight: item.minHeight}
        }
        return {height: item.height ? item.height : '60px'}
      },
      contentStyle(item) {
        if (!item.minHeight) {
          return {
            'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'display': '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical'
          }
        }
      },
      componentDidMount(refName) {
        if (!refName) return
        this.$nextTick(() => {
          const node = this.$refs[refName] ? this.$refs[refName][0] : null
          const clientWidth = node.clientWidth
          const scrollWidth = node.scrollWidth
          if (clientWidth < scrollWidth) {
            if (this.ellipsisList.indexOf(refName) === -1) {
              this.ellipsisList.push(refName)
            }
          }
        });
      },
      disabledTools(item) {
        if (item.minHeight) {
          return true
        } else if (!this.value[item.prop]) {
          return true
        } else if (this.ellipsisList.includes(item.prop)) {
          return true
        }
      }
    }
  }
</script>

<style scoped>

  .table-wrap {
    --border-color: #BFE7E7;
    margin: 30px;
    border-left: 1px solid var(--border-color);
    border-top: 1px solid var(--border-color);
    line-height: 1.4;
    box-sizing: border-box;
    color: #333;
    font-family: PingFang-SC-Regular;
    font-size: 14px;
  }

  .table-wrap .table-content-item {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
    border-bottom: 1px solid var(--border-color);
    vertical-align: top;
    width: 100%;
    background-color: #F0FBFC;
  }

  .table-wrap .table-content-item .content-label {
    background-color: #F0FBFC;
    padding: 10px;
    overflow: hidden;
    height: 100%;
    color: #333;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 0;*/
    /*bottom: 0;*/
  }

  .table-wrap .table-content-item .content-label ::after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .table-wrap .table-content-item .content-label-text {
    display: inline-block;
    vertical-align: middle;
    line-height: 1.4;
    width: 80%;
  }

  .table-wrap .table-content-item .content {
    height: 100%;
    border-right: 1px solid var(--border-color);
    border-left: 1px solid var(--border-color);
    padding: 10px;
    background: #fff;
    overflow: hidden;
  }

  .table-wrap .table-content-item .content-text {
    height: 100%;
    width: 100%;
    cursor: pointer;
    overflow: hidden;
  }

  /*.hidden-xs-only .table-content-item {
    display: none;
  }*/
  /*@media (max-width: 750px) {
    .table-wrap {
      border: none!important;
    }
    .table-wrap .table-content-item {
      background: none;
      border: none!important;
    }
    .table-wrap .table-content-item .content-label {
      background: none!important;
      text-align: left;
      justify-content: flex-start;
      position: relative;
    }
    .table-wrap .table-content-item .content-label:after {
      position: absolute;
    }
    .table-wrap .table-content-item .content {
      border: none!important;
      background: none;
    }
  }*/
</style>

<style>
  .el-tooltip__popper.is-light {
    border: 2px solid #d9d9d9;
    font-size: 15px;
    max-width: 450px;
  }

  .el-tooltip__popper.is-light[x-placement^="top"] .popper__arrow {
    border-top-color: #d9d9d9;
  }
</style>
